import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

// Import your PDFs (adjust paths as needed)
import RTI_Hindi from '../assets/RTI-Act-Hindi.pdf';
import RTI_English from '../assets/RTI-Act_English.pdf';

const tabSections = [
    { id: "intro", label: "'सूचना का अधिकार' परिचय" },
    { id: "downloads", label: "डाउनलोड / खोलें" },
    { id: "spio", label: "SPIO अधिकारी एवं सदस्य" },
];

const spioOfficers = [
    { id: 1, name: "श्री अंकुर गुप्ता", email: "spio@mvsu.ac.in", mobile: "8950365565" }
];

const spioMembers = [
    { id: 1, name: "श्री अंकुर गुप्ता", position: "SPIO", email: "spio@mvsu.ac.in", mobile: "8950365565" },
    { id: 2, name: "श्री अंकुर", position: "DEO", email: "asbairagiofficial@gmail.com", mobile: "7900163001" }
];

const downloadOptions = [
    { title: "'सूचना का अधिकार' अधिनियम (हिन्दी)", file: RTI_Hindi },
    { title: "'सूचना का अधिकार' अधिनियम (अंग्रेजी)", file: RTI_English }
];

export default function RighttoInformation() {
    const [activeTab, setActiveTab] = useState("intro");
    const [showSidebar, setShowSidebar] = useState(true);

    const activeColor = "#77236b";

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle button for small screens */}
            <button
                className="btn btn-primary d-md-none m-2 shadow-sm"
                onClick={() => setShowSidebar(!showSidebar)}
                aria-label="Toggle menu"
            >
                मेनू
            </button>

            {/* Sidebar */}
            <aside
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}
                style={{ minWidth: 220, backgroundColor: "#f8f9fa" }}
            >
                <h5 className="text-center fw-bold mb-3" style={{ color: activeColor }}>
                    सूचना का अधिकार
                </h5>
                <div className="flex-grow-1 overflow-auto">
                    {tabSections.map((tab) => (
                        <p
                            key={tab.id}
                            className={`mb-2 p-2 rounded shadow-sm small transition-all ${activeTab === tab.id ? "text-white fw-bold" : "bg-white text-dark hover-effect"
                                }`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: activeTab === tab.id ? activeColor : "",
                                fontWeight: activeTab === tab.id ? 700 : 400,
                            }}
                            onClick={() => {
                                setActiveTab(tab.id);
                                setShowSidebar(false);
                            }}
                        >
                            {tab.label}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main content */}
            <main
                className="flex-grow-1 p-4 bg-white shadow col-md-9 overflow-auto"
                onClick={() => setShowSidebar(false)}
                tabIndex={-1}
            >
                <h4 className="text-center mb-4 fw-bold" style={{ color: activeColor }}>
                    {tabSections.find((t) => t.id === activeTab)?.label}
                </h4>

                {/* Tab Contents */}
                {activeTab === "intro" && (
                    <>
                        <p className="lh-lg text-justify mb-3">
                            सूचना के अधिकार अधिनियम का मूल उद्देश्य नागरिकों को सशक्त बनाना, सरकार के कामकाज में पारदर्शिता और जवाबदेही को बढ़ावा देना,
                            भ्रष्टाचार को रोकना और हमारे लोकतंत्र को वास्तविक अर्थों में लोगों के लिए काम करने योग्य बनाना है। एक जागरूक नागरिक शासन के साधनों
                            पर आवश्यक निगरानी रखने और सरकार को शासितों के प्रति अधिक जवाबदेह बनाने के लिए बेहतर ढंग से सुसज्जित होगा।
                        </p>
                        <div className="bg-light rounded-3 p-3">
                            <h6 className="text-success fw-bold mb-2">Right to Information Act, 2005:</h6>
                            <p className="mb-0 text-justify small lh-lg">
                                The basic object of the Right to Information Act is to empower the citizens, promote transparency and accountability in the working
                                of the Government, contain corruption, and make our democracy work for the people in a real sense. An informed citizenry will be better
                                equipped to keep necessary vigil on the governance instruments and make the government more accountable to the governed.
                            </p>
                        </div>
                    </>
                )}

                {activeTab === "downloads" && (
                    <>
                        <div className="row g-3">
                            {downloadOptions.map((item, idx) => (
                                <div key={idx} className="col-md-6">
                                    <div className="card h-100 border-0 shadow-sm">
                                        <div className="card-body d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h6 className="card-title mb-2 fw-bold">{item.title}</h6>
                                                <div className="d-flex gap-2">
                                                    <a
                                                        href={item.file}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-outline-primary btn-sm"
                                                    >
                                                        Open
                                                    </a>
                                                    <a href={item.file} download className="btn btn-success btn-sm">
                                                        Download
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}

                {activeTab === "spio" && (
                    <>
                        {/* SPIO अधिकारी टेबल */}
                        <h5 className="mb-3 text-primary fw-bold">SPIO अधिकारी </h5>
                        <div className="table-responsive mb-5">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>क्र.सं.</th>
                                        <th>नाम</th>
                                        <th>ई-मेल</th>
                                        <th>मोबाइल</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {spioOfficers.map((officer) => (
                                        <tr key={officer.id}>
                                            <td className="text-primary fw-bold">{officer.id}</td>
                                            <td className="fw-semibold">{officer.name}</td>
                                            <td>
                                                <a href={`mailto:${officer.email}`} className="text-decoration-none">
                                                    {officer.email}
                                                </a>
                                            </td>
                                            <td>
                                                <a href={`tel:${officer.mobile}`} className="text-decoration-none">
                                                    {officer.mobile}
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* SPIO सदस्य टेबल */}
                        <h5 className="mb-3 text-primary fw-bold">SPIO  सदस्य</h5>
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>क्र.सं.</th>
                                        <th>नाम</th>
                                        <th>पद</th>
                                        <th>ई-मेल</th>
                                        <th>मोबाइल</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {spioMembers.map((member) => (
                                        <tr key={member.id}>
                                            <td className="text-success fw-bold">{member.id}</td>
                                            <td className="fw-semibold">{member.name}</td>
                                            <td>
                                                <span className="badge bg-info text-dark">{member.position}</span>
                                            </td>
                                            <td>
                                                <a href={`mailto:${member.email}`} className="text-decoration-none">
                                                    {member.email}
                                                </a>
                                            </td>
                                            <td>
                                                <a href={`tel:${member.mobile}`} className="text-decoration-none">
                                                    {member.mobile}
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </main>
        </div>
    );
}
